import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";
//const rootUrl = "http://local.vbg.enjo.software/api/distributors/settings";

export function getActiveSettings(accessToken) {
  // init session by token, no need to login again and re create session, if from mobile app
  if(accessToken){
    axios.defaults.headers.common['Authorization'] = accessToken;
  }

  const request = axios.get(urls.SETTINGS_URL);
  return { type: ActionTypes.GET_ACTIVE_SETTINGS, payload: request, meta: { accessToken } };
}


export function getSiteLinks() {
    const request = axios.get(urls.SITE_LINKS_URL);
    return { type: ActionTypes.GET_SITE_LINKS, payload: request };
}
